var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DrawerBody } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { DateTime } from 'luxon';
import React, { useEffect, useState, } from 'react';
import { SubmitDeliveryAddressGetCitiesByZipCode } from '../../../api/oms/edit-delivery-address';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { OmmAvailableDeliverySlots } from '../../../hooks/delivery-hooks';
import { useExperienceContext, useOrderContext, useFulfillmentGroupContext, } from '../../../hooks/useContexts';
import { EditDeliveryAddressErrorMessages, } from '../../../models/edit-delivery-address';
import '../../../styles/drawer.scss';
import { getAddresses, submitEditDeliveryAddress, validateDeliveryAddress, } from '../../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { getWindow } from '../../../utils/general';
import { areAddressesEqual, extractAddressFromFulfillmentGroup, } from '../../../utils/order-details/OrderDetailsUtils';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { getFlowTypeValue } from '../util/OutOfStock';
import { EditDeliveryAddressChangeFormBody } from './EditDeliveryAddressChangeFormBody';
import { EditDeliveryAddressChangeFormFooter } from './EditDeliveryAddressChangeFormFooter';
import { EditDeliveryAddressChooseAddress } from './EditDeliveryAddressChooseAddress';
export var EditDeliveryAddressChangeForm = function (_a) {
    var _b, _c, _d;
    var firstNameValue = _a.firstNameValue, lastNameValue = _a.lastNameValue, phoneNumberValue = _a.phoneNumberValue, streetAddressValue = _a.streetAddressValue, addressLineTwoValue = _a.addressLineTwoValue, zipCodeValue = _a.zipCodeValue, cityStateValue = _a.cityStateValue, enteredEditFlow = _a.enteredEditFlow, closeDrawer = _a.closeDrawer, setFirstName = _a.setFirstName, setLastName = _a.setLastName, setPhoneNumber = _a.setPhoneNumber, setStreetAddress = _a.setStreetAddress, setAddressLineTwo = _a.setAddressLineTwo, setZipCode = _a.setZipCode, setCityState = _a.setCityState, setIsChangeForm = _a.setIsChangeForm, setEnteredEditFlow = _a.setEnteredEditFlow, setShowDrawerError = _a.setShowDrawerError, setIsDeliveryDetails = _a.setIsDeliveryDetails, setUpdatedAddressData = _a.setUpdatedAddressData, setNewDeliveryAddressDetails = _a.setNewDeliveryAddressDetails, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, previousCountry = _a.previousCountry, setIsAddressList = _a.setIsAddressList, isAddressList = _a.isAddressList, isDefaultValue = _a.isDefaultValue, setIsDefault = _a.setIsDefault, setOpen = _a.setOpen, isLoading = _a.isLoading, setIsLoading = _a.setIsLoading, isExcludedAddress = _a.isExcludedAddress, setIsExcludedAddress = _a.setIsExcludedAddress, isValidated = _a.isValidated, setIsValidated = _a.setIsValidated, deliveryAddressCreateCartRequestData = _a.deliveryAddressCreateCartRequestData, submitCreateForm = _a.submitCreateForm, setSubmitCreateForm = _a.setSubmitCreateForm;
    var _e = useFulfillmentGroupContext(), fulfillmentGroup = _e.fulfillmentGroup, fulfillmentGroupIndex = _e.fulfillmentGroupIndex;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _f = useOrderContext(), setAvailableDeliverySlots = _f.setAvailableDeliverySlots, setSelectedDateId = _f.setSelectedDateId, setAvailableDeliverySlotsResponse = _f.setAvailableDeliverySlotsResponse, orderDetailsData = _f.orderDetailsData;
    var _g = useOrderContext(), currentDrawer = _g.currentDrawer, setDeliveryAddresses = _g.setDeliveryAddresses, setDeliveryAddressesApiError = _g.setDeliveryAddressesApiError, setDeliveryAvailableSlotsApiError = _g.setDeliveryAvailableSlotsApiError;
    var _h = useState(false), invalidField = _h[0], setInvalidField = _h[1];
    var _j = useState(''), validationEt = _j[0], setValidationEt = _j[1];
    var _k = useState(previousCountry), country = _k[0], setCountry = _k[1];
    var _l = useState(false), isPOBoxAddressLine1 = _l[0], setIsPOBoxAddressLine1 = _l[1];
    var _m = useState(false), isPOBoxAddressLine2 = _m[0], setIsPOBoxAddressLine2 = _m[1];
    var _o = useState(false), isZipCodeChanged = _o[0], setIsZipCodeChanged = _o[1];
    var _p = useState([]), getCitiesByZipCode = _p[0], setGetCitiesByZipCode = _p[1];
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var traceId = orderDetailsData.traceId;
    var flowType = getFlowTypeValue(currentDrawer, FLOW_TYPES.EDIT_DELIVERY_ADDRESS);
    var _q = useState(false), isSameAddress = _q[0], setIsSameAddress = _q[1];
    var _r = useState(''), selectedAddressId = _r[0], setSelectedAddressId = _r[1];
    var _s = useThdCustomer() || {}, isLoggedIn = _s.isLoggedIn, isExchangeCustomer = _s.isExchangeCustomer;
    var isAuthTHDUser = Boolean(isLoggedIn && !isExchangeCustomer);
    var isAddingNewAddress = Boolean(FeatureSwitches.enableEditDeliveryAddressAppify) && !isAddressList;
    var fulfillmentTypeCode = ((_c = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || undefined;
    var _t = extractAddressFromFulfillmentGroup(fulfillmentGroup.shippingAndHandling ||
        fulfillmentGroup.storePickup ||
        fulfillmentGroup.bodfsDeliveryAndHandling, fulfillmentGroup.fulfillmentType), firstName = _t.firstName, lastName = _t.lastName, addressLine1 = _t.addressLine1, addressLine2 = _t.addressLine2, zipCode = _t.zipCode, city = _t.city, state = _t.state, phoneNumber = _t.phoneNumber;
    useEffect(function () {
        if (!submitCreateForm.value)
            return;
        // Address has been validated
        if (fulfillmentGroup.fulfillmentType === FULFILLMENT_TYPE.BODFS) {
            getAvailableSlots();
        }
        else {
            submitEditDeliveryAddress({
                deliveryAddress: deliveryAddress,
                firstNameValue: firstNameValue,
                lastNameValue: lastNameValue,
                phoneNumberValue: phoneNumberValue,
                isDefaultValue: isDefaultValue,
                orderDetailsData: orderDetailsData,
                fulfillmentTypeCode: fulfillmentTypeCode,
                deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData,
                isAddingNewAddress: isAddingNewAddress,
                fulfillmentGroupIndex: fulfillmentGroupIndex,
                fulfillmentGroup: fulfillmentGroup,
                traceId: traceId,
                setIsChangeForm: setIsChangeForm,
                setIsDeliveryDetails: setIsDeliveryDetails,
                setIsLoading: setIsLoading,
                setShowDrawerError: setShowDrawerError,
                setIsExcludedAddress: setIsExcludedAddress,
                setIsValidated: setIsValidated,
                closeDrawer: closeDrawer,
                setUpdatedAddressData: setUpdatedAddressData,
                setEditDeliveryAddressAlert: setEditDeliveryAddressAlert,
                flowType: flowType,
            });
        }
        // reset submitCreateForm to false
        setSubmitCreateForm({ value: false, et: '' });
    }, [submitCreateForm]);
    useEffect(function () {
        var _a, _b;
        if (getCitiesByZipCode.length > 0 && isZipCodeChanged) {
            setCityState("".concat((_a = getCitiesByZipCode[0]) === null || _a === void 0 ? void 0 : _a.city, ", ").concat((_b = getCitiesByZipCode[0]) === null || _b === void 0 ? void 0 : _b.stateCode));
            setIsZipCodeChanged(false);
        }
    }, [getCitiesByZipCode]);
    useEffect(function () {
        setIsExcludedAddress(false);
    }, [streetAddressValue, zipCodeValue, addressLineTwoValue]);
    var deliveryAddress = {
        addressLine1: streetAddressValue || '',
        addressLine2: addressLineTwoValue || null,
        city: cityStateValue.split(',')[0],
        state: (_d = cityStateValue === null || cityStateValue === void 0 ? void 0 : cityStateValue.split(',')[1]) === null || _d === void 0 ? void 0 : _d.trim(),
        zipCode: zipCodeValue,
        country: country,
    };
    var getAvailableSlots = function () {
        var _a, _b;
        var availableSlotsRequest = {
            flowType: FLOW_TYPES.EDIT_DELIVERY_ADDRESS,
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
            fulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
            deliverySlotTypes: ['All Day'],
            et: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.et,
            net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
            lineItems: ((_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b.map(function (type) { return ({
                lineId: type.lineId,
                omsId: "".concat(type.secOmsId),
                sku: "".concat(type.skuNumber),
                price: type.unitPrice,
                quantity: type.currentQuantity,
            }); })) || [],
            fulfillmentAddress: deliveryAddress,
        };
        OmmAvailableDeliverySlots(availableSlotsRequest, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
            .then(function (response) {
            var _a, _b;
            var data = response.data.data;
            setAvailableDeliverySlotsResponse(data);
            var sortedSlots = __spreadArray([], ((_a = data === null || data === void 0 ? void 0 : data.availableDeliverySlots) !== null && _a !== void 0 ? _a : []), true).sort(function (slotA, slotB) {
                return DateTime.fromISO(slotA.startDateTime).toMillis() -
                    DateTime.fromISO(slotB.startDateTime).toMillis();
            });
            setSelectedDateId(((_b = sortedSlots === null || sortedSlots === void 0 ? void 0 : sortedSlots[0]) === null || _b === void 0 ? void 0 : _b.id) || '');
            setAvailableDeliverySlots(sortedSlots);
            setIsChangeForm(false);
            setIsDeliveryDetails(true);
            setDeliveryAvailableSlotsApiError(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
            });
        })
            .catch(function () {
            setDeliveryAvailableSlotsApiError(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
            });
            setOpen(false);
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var handleClearAll = function () {
        setFirstName('');
        setLastName('');
        setStreetAddress('');
        setAddressLineTwo(null);
        setZipCode('');
        setCityState('');
        setCountry(previousCountry);
        setIsSameAddress(false);
        setIsDefault(false);
    };
    var checkSameAddress = function () {
        return areAddressesEqual({
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            city: city,
            state: state,
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            zipCode: zipCode,
            country: country,
        }, __assign({ firstName: firstNameValue, lastName: lastNameValue, phoneNumber: phoneNumberValue }, deliveryAddress));
    };
    var handleValidateDeliveryAddress = function () {
        validateDeliveryAddress({
            firstNameValue: firstNameValue,
            lastNameValue: lastNameValue,
            phoneNumberValue: phoneNumberValue,
            streetAddressValue: streetAddressValue,
            addressLineTwoValue: addressLineTwoValue,
            zipCodeValue: zipCodeValue,
            cityStateValue: cityStateValue,
            country: country,
            flowType: flowType,
            fulfillmentTypeCode: fulfillmentTypeCode,
            orderDetailsData: orderDetailsData,
            setInvalidField: setInvalidField,
            setIsSameAddress: setIsSameAddress,
            setIsLoading: setIsLoading,
            setNewDeliveryAddressDetails: setNewDeliveryAddressDetails,
            setShowDrawerError: setShowDrawerError,
            fulfillmentGroupIndex: fulfillmentGroupIndex,
            setIsValidated: setIsValidated,
            closeDrawer: closeDrawer,
            setValidationEt: setValidationEt,
            validationEt: validationEt,
            traceId: traceId,
            deliveryAddress: deliveryAddress,
            checkSameAddress: checkSameAddress,
            isPOBoxAddressLine1: isPOBoxAddressLine1,
            isPOBoxAddressLine2: isPOBoxAddressLine2,
            setSubmitCreateForm: setSubmitCreateForm,
            EditDeliveryAddressErrorMessages: EditDeliveryAddressErrorMessages,
            isValidated: isValidated,
            isAddressList: isAddressList,
        });
    };
    var handleChange = function (event) {
        setCityState(event.target.value);
    };
    var handleZipCodeValueChange = function (zipCodeChange) {
        var request = {
            zipCode: zipCodeChange || zipCode,
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            flowType: flowType,
            fulfillmentType: fulfillmentTypeCode,
        };
        setGetCitiesByZipCode([]);
        SubmitDeliveryAddressGetCitiesByZipCode(request, setGetCitiesByZipCode, setIsChangeForm, setShowDrawerError, fulfillmentGroupIndex, traceId);
    };
    useEffect(function () {
        if (!currentDrawer && !enteredEditFlow)
            handleZipCodeValueChange();
        setEnteredEditFlow(true);
        if (isAddressList) {
            getAddresses({
                orderDetailsData: orderDetailsData,
                fulfillmentTypeCode: fulfillmentTypeCode,
                isAuthTHDUser: isAuthTHDUser,
                fulfillmentGroupIndex: fulfillmentGroupIndex,
                setDeliveryAddresses: setDeliveryAddresses,
                setDeliveryAddressesApiError: setDeliveryAddressesApiError,
                closeDrawer: closeDrawer,
            });
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null, isAddressList ? (React.createElement(EditDeliveryAddressChooseAddress, { setFirstName: setFirstName, setLastName: setLastName, setPhoneNumber: setPhoneNumber, setStreetAddress: setStreetAddress, setAddressLineTwo: setAddressLineTwo, setZipCode: setZipCode, setCityState: setCityState, setCountry: setCountry, handleClearAll: handleClearAll, selectedAddressId: selectedAddressId, setSelectedAddressId: setSelectedAddressId, setIsAddressList: setIsAddressList, setIsDefault: setIsDefault, isExcludedAddress: isExcludedAddress, isSameAddress: isSameAddress, setIsSameAddress: setIsSameAddress })) : (React.createElement(EditDeliveryAddressChangeFormBody, { getCitiesByZipCode: getCitiesByZipCode, firstNameValue: firstNameValue, lastNameValue: lastNameValue, phoneNumberValue: phoneNumberValue, streetAddressValue: streetAddressValue, addressLineTwoValue: addressLineTwoValue, zipCodeValue: zipCodeValue, cityStateValue: cityStateValue, invalidField: invalidField, isExcludedAddress: isExcludedAddress, isValidated: isValidated, setIsValidated: setIsValidated, isPOBoxAddressLine1: isPOBoxAddressLine1, setIsPOBoxAddressLine1: setIsPOBoxAddressLine1, isPOBoxAddressLine2: isPOBoxAddressLine2, setIsPOBoxAddressLine2: setIsPOBoxAddressLine2, setFirstName: setFirstName, setLastName: setLastName, setStreetAddress: setStreetAddress, setAddressLineTwo: setAddressLineTwo, setZipCode: setZipCode, setIsZipCodeChanged: setIsZipCodeChanged, handleZipCodeValueChange: handleZipCodeValueChange, handleChange: handleChange, isSameAddress: isSameAddress, setIsSameAddress: setIsSameAddress, setCityState: setCityState, handleClearAll: handleClearAll }))),
        React.createElement(EditDeliveryAddressChangeFormFooter, { isLoading: isLoading, isValidated: isValidated, isIosMobile: isIosMobile, handleValidateDeliveryAddress: handleValidateDeliveryAddress, closeDrawer: closeDrawer, isAddressList: isAddressList, selectedAddressId: selectedAddressId })));
};
